// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"1fc6b241","612":"10f7edc8","722":"6e9befc5","1470":"6e9befc5","1545":"10f7edc8","4572":"6e9befc5","5478":"10f7edc8","6152":"6e9befc5","9380":"475be324"}[chunkId] + ".chunk.css";
};